import { IconProps } from '@/assets/types/icon'

const InstagramLogo = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.0364 0H15.9636C7.14713 0 0 7.14713 0 15.9636V16.0364C0 24.8529 7.14713 32 15.9636 32H16.0364C24.8529 32 32 24.8529 32 16.0364V15.9636C32 7.14713 24.8529 0 16.0364 0Z"
        fill="#7D7D7D"
      />
      <path
        d="M20.9514 6.51034H11.0497C8.31422 6.51034 6.08881 8.73575 6.08881 11.4713V20.5299C6.08881 23.2654 8.31422 25.4908 11.0497 25.4908H20.9514C23.687 25.4908 25.9124 23.2654 25.9124 20.5299V11.4713C25.9124 8.73575 23.687 6.51034 20.9514 6.51034ZM7.83887 11.4713C7.83887 9.70103 9.2795 8.2604 11.0497 8.2604H20.9514C22.7217 8.2604 24.1623 9.70103 24.1623 11.4713V20.5299C24.1623 22.3001 22.7217 23.7408 20.9514 23.7408H11.0497C9.2795 23.7408 7.83887 22.3001 7.83887 20.5299V11.4713Z"
        fill="white"
      />
      <path
        d="M16.0006 20.614C18.5444 20.614 20.6151 18.5445 20.6151 15.9995C20.6151 13.4546 18.5455 11.385 16.0006 11.385C13.4557 11.385 11.3861 13.4546 11.3861 15.9995C11.3861 18.5445 13.4557 20.614 16.0006 20.614ZM16.0006 13.1362C17.5803 13.1362 18.8651 14.421 18.8651 16.0006C18.8651 17.5803 17.5803 18.8651 16.0006 18.8651C14.421 18.8651 13.1362 17.5803 13.1362 16.0006C13.1362 14.421 14.421 13.1362 16.0006 13.1362Z"
        fill="white"
      />
      <path
        d="M21.0423 12.1306C21.7273 12.1306 22.2856 11.5734 22.2856 10.8873C22.2856 10.2011 21.7284 9.64395 21.0423 9.64395C20.3561 9.64395 19.799 10.2011 19.799 10.8873C19.799 11.5734 20.3561 12.1306 21.0423 12.1306Z"
        fill="white"
      />
    </svg>
  )
}

export default InstagramLogo
